export const DeclarationIrg301Bis = {
    path: '/declaration_irg_301_bis',
    name: 'declaration_irg_301_bis',
    component: () => import('@/views/Impression/DeclarationIrg301Bis/DeclarationIrg301BisPage.vue'),
}